module.exports = __webpack_public_path__ + "media/images/common/bg1-e8172fb8f27997fbdefdd689dcaa122b.png";